<template>
    <div>
        <multiselect
                v-bind:multiple="true"
                v-bind:close-on-select="false"
                v-bind:options="options"
                v-bind:internal-search="false"
                v-bind:searchable="false"
                v-model="selected"
                placeholder="Please select all that apply">
        </multiselect>

        <input v-for="value in selected" v-bind:name="fieldId + '[]'" type="hidden" v-bind:value="value">
    </div>
</template>

<script>
    export default {
        props: ['options', 'fieldId', 'init'],

        data() {
            return {
                selected: this.init ? this.init : [],
            }
        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// modules/Core/Assets/vue/shared/MultiselectField.vue